<template><div class="editor-main" style="overflow: hidden;">
	<div class="editor fl" ref="editor" :style="edstyle">
		<draggable v-if="! ispreview" class="phonetop" :options="{group: {name: 'phonetop',pull: false,put: false},scroll: false}">
	        <img src="../assets/top.png" />
		</draggable>
		<div v-bar="{preventParentScroll: true,scrollThrottle: 30}" id="scroll_container" :style="scstyle"><div>
			<draggable :style="pagestyle" id="canvas" v-model="tree_modules" :options="{disabled: ispreview,group: {name: 'sort1',pull: false},handle: '.myhandler',ghostClass: 'sortghost',scroll: true}">
            	<wp-module :id="child.id" v-for="(child, m) in tree_modules" :mod_param="child.orimodinf" :children="child.children" :is_active="child.active" :active="child.active" :position="'relative'" :islast="(tree_modules.length == m + 1)?true:false" :key="child.id"></wp-module>
            	<div class="place-holder" :style="{'height': placeholder_height+'px'}"></div>
			</draggable>
        </div></div>
		<draggable v-if="! ispreview" class="phonebottom" :options="{group: {name: 'phonetop',pull: false,put: false},scroll: false}" :style="{'top': `${btmtop}px`}">
			<img src="../assets/bottom.png" />
		</draggable>
	</div>
	<div v-if="! ispreview" class="propanel fr">
		<property :attrs="propInfo" :height="height"></property>
	</div>
	
	<setting v-if="show_setdialog && ! ispreview"></setting>
</div></template>


<script>
import jGlobal from '@/global';
import Mods from '@/common/mods';
import EventBus from '@/common/events';
import draggable from '@/components/vuedraggable/vuedraggable';
import WpModule from '@/components/module';
import Property from '@/components/property';
import Setting from '@/components/setting';

let propInfo = {"type": 'page'};
export default
{
	name: 'weditor',
	data (){
		return {
			propInfo,
			btmtop: 0,
			active_mod: '',
			child_changed: false,
			show_setdialog: false,
			pageinfo: {},
			pagestyle: {},
			childzIndex: {},
			modules: [],
			popAttrs: {},
			ubehaviors: [],
			placeholder_height: 0,
		}
	},
	created (){
		// 'User-(un)behavior' Listener
		EventBus.$on("user_unbehavior", () => this.ubehaviors = []);
		EventBus.$on("user_behavior", v => {
			let tmparr = this.ubehaviors;
			if ($.inArray(v, tmparr) < 0) this.ubehaviors.push(v)
		});
		// 'Dragable' Listener
		EventBus.$on("addplugin_bydrag", (etype, ...extra) => {
			if (etype && extra.length
				&& /function/i.test(typeof this[etype])) this[etype](...extra)
		});
		// 'Place-holder show or not'
		EventBus.$on("placeholder_reheight", h => this.placeholder_height = h);
		// for 'pagesave-listener'
		EventBus.$on("pagesave", () => {
			let that = this;
			(new Promise((resolve, reject) => {
				let enumArr = ['display', 'ishome'],
				locsearch = jGlobal.parSearch(),
				frmdata = Object.assign({}, this.pageinfo);
				// Boolean -> String
				enumArr.forEach(v => frmdata[v] = frmdata[v] ? '1' : '0');
				if ('home' == locsearch['hash']||'') frmdata['ishome'] = '1';
				if ('shop' == locsearch['hash']||'') frmdata['query_hash'] = 'wxshop';
				// filter frmdata
				enumArr.push('id', 'name', 'query_hash', 's_params');
				for (let idx in frmdata) {
					if ($.inArray(idx, enumArr) < 0)
						delete frmdata[idx]
				}
				
				jGlobal.xhrPost('page/create', {frmdata}, res => {
					if ('OK' == (res || {}).result) {
						resolve(res.data.pageid);
						return false;
					}
					
					this.$Notice.warning({
						title: '页面更新失败',
						desc: `${frmdata.name} - ${res.data.errmsg}`
					})
				}, err => console.error(err))
		    })).then(pageid => {
				jGlobal.pageSave(that, pageid);
				EventBus.$emit("user_unbehavior")
			})
		});

		this.$nextTick(() => {
			let that = this, boxer = that.$refs.editor,
			headerh = jGlobal.HEADERH, placeh = 30, btmh = 60;
			$(window).on("resize", function(e){
				let winheight = $(this).height(),
				maxh = winheight - headerh;
				that.btmtop = maxh - placeh - btmh / 2;
				let scheight = that.ispreview ? winheight : (maxh - placeh - btmh);
				if (that.ispreview) maxh = winheight;
				$(boxer).height(maxh).find('#scroll_container').height(scheight)
			}).trigger("resize")
		});

		this.$watch('modules', (newval, oldval) => {
			if (newval.length == 0) return false;
			EventBus.$emit("user_behavior", 'edit_plugin')
		}, {deep: true});

		let isTextarea = e => {
			let $target = $(e.target);
			return $target.is('textarea') || $target.is('input')
		};
		document.onkeydown = e => {
			e = e || window.event;
			if (e.ctrlKey && e.keyCode == 83) {
				EventBus.$emit("pagesave");
				return false
			}
			// for 'delete'
			let rmid = window.actived_layerid;
			if (/^layer[0-9A-Z]+$/i.test(rmid)
				&& e.keyCode == 46) {
				if (isTextarea(e)) return true;
				EventBus.$emit("mod_remove", rmid)
			}
		}
	},
	mounted (){
		let curpage = jGlobal.getCurPage();
		this.modules = curpage.modinfo;
		// 'Page - style'
		this.pageinfo = curpage.pageinfo;
		this.pagestyle = $.extend({}, this.pageinfo.s_params || {});
		if ($.isPlainObject(this.pagestyle)) {
			let bgimgstr = this.pagestyle['background-image'] || 'none';
			if (bgimgstr != 'none') this.pagestyle['background-image'] = `url(${bgimgstr})`
		} else this.pagestyle = {};

		this.$watch('pageinfo.s_params', res => {
			if (! $.isPlainObject(res)) return false;
			let bgimg = res['background-image'] || 'none';
			if (bgimg != 'none') res = $.extend({}, res, {'background-image': `url(${bgimg})`});
			this.pagestyle = res
		});

		$('#scroll_container').on("scrolltoup scrolltodown", e => {
			let step = (e.type == 'scrolltoup') ? -15 : 15,
		    barstate = this.$vuebar.getState(e.target),
		    scrollt = barstate.el2.scrollTop + step;
		    
		    barstate.el2.scrollTop = scrollt;
			this.$vuebar.refreshScrollbar(e.target)
		});

		document.body.ondrop = e => {
			e.preventDefault();
			e.stopPropagation()
		};

		EventBus.$on("mod_activate", mod_id => {
			let modparams = this.modules.find(c => c.id == mod_id);
			if (modparams == null) return false;
		    this.propShow({"status": 'Activated',"target": modparams});
		    this.active_mod = mod_id
		});

		EventBus.$on("mod_deactivate", () => {
			this.active_mod = '';
			let target = event.target || event.srcElement;
			if (! $(target).closest('.cstlayer').length) this.propShow({"status": 'Deactivated'});
			$('.cstlayer > .removit').hide()
		});

		// 'Setting' listener
		EventBus.$on("show_setting", () => this.show_setdialog = true);
		EventBus.$on("hide_setting", () => this.show_setdialog = false);

		// 'Plugin-remove' listener
		EventBus.$on("mod_remove", id => {
			let that = this;
			that.$Modal.confirm({
				content: '确定要删除该元素吗？',
				onOk (){
					let idx = that.modules.findIndex(c => c.id==id);
					if (idx < 0) return false;

					let curobj = that.modules[idx];
					that.modules.splice(idx, 1);
					// for 'freelayout'
					if (! curobj.parent) {
						that.modules.find((c, i) => {
							if (!c) return true;
							(c.parent == id) && that.modules.splice(i, 1);
							return false
						})
					}
					if ($.isArray(curpage.rmids || '')) curpage.rmids.push(id);
					EventBus.$emit("user_behavior", 'mod_remove')
				}
			})
		});

		// listener
		document.documentElement.addEventListener("mousedown", this.globalMouseDown, true);
		$(window).on("beforeunload", e => {
			if (! this.ispreview && this.ubehaviors.length) {
				return "系统含有未保存的操作，是否确认要离开或关闭该页面？"
			}
		});
		document.onselectstart = () => {return false}
	},
	beforeDestroy (){
		document.onselectstart = () => {return true}
		document.documentElement.removeEventListener("mousedown", this.globalMouseDown, true)
	},
	computed: {
		edstyle (){
			let height = '', margin = '';
			if (this.ispreview) {height = '100%';margin = '0px'}
			return {height, margin}
		},
		scstyle (){
			let tmpobj = {width: '','border-left-width': '1px','border-right-width': '1px','margin-top': ''};
			if (this.ispreview) {
				tmpobj.width = '375px';
				tmpobj['border-left-width'] = '0px';
				tmpobj['border-right-width'] = '0px';
				tmpobj['margin-top'] = '0px'
			}
			return tmpobj
		},
		tree_modules: {
			get (){
				let moduleshash = {}, newmodules = [], othermodules = [];
				for (let i = 0, ln = this.modules.length; i < ln; i++) {
					let orimodinf = this.modules[i],
					wrapmodinf = {"id": orimodinf.id,"orimodinf": orimodinf,"children": [],
						"zindex": orimodinf.zindex,"active": (this.active_mod == orimodinf.id) ? true : false};
					moduleshash[orimodinf.id] = wrapmodinf;
					if ($.inArray(orimodinf.parent, ['', '0']) > -1) newmodules.push(wrapmodinf)
					else othermodules.push(wrapmodinf)
				}

				for (let i = 0, ln = othermodules.length; i < ln; i++) {
					let otherwrapinf = othermodules[i],
					modparent = otherwrapinf.orimodinf.parent;
					if (moduleshash[modparent]) moduleshash[modparent].children.push(otherwrapinf);
					this.childzIndex[modparent] = (this.childzIndex[modparent] || '') + otherwrapinf.zindex + ','
				}

				newmodules.sort((a, b) => {
					let aidx = a.zindex || 0, bidx = b.zindex || 0;
					return aidx - bidx
				});

				return newmodules
			},
			set (newmodules){
				let ln = newmodules.length;
				for (let i = 0; i < ln; i++) {
					newmodules[i].orimodinf.zindex = i
				}
			}
	    },
	},
	methods: {
		onEnd (e, dragEvt){
			let modinfo, childparam = {}, draginlayout = false,
			type = e.item.getAttribute("data-role"), $target = $(e.item);
		    
		    if ($target.closest('.cstlayer').length > 0) {
		    	let dragId = $target.closest('.cstlayer').prop('id');
		        childparam = EventBus.Emit(dragId, 'add_child', {item: e.item,e: e});
		        draginlayout = true
			}

		    if (! draginlayout) {
		        let minBigzindex = -1,
		        pos = $target.prevAll('.mod_wrapper').length;
		        if (pos < this.tree_modules.length) {
					minBigzindex = this.tree_modules[pos].orimodinf.zindex
		        }
		        modinfo = Mods.get_default_plugin(type, {"zindex": minBigzindex})
			} else {
		        modinfo = Mods.get_default_plugin(type, childparam);
				// Set 'plug-in' position
				let offset = $(`#${childparam.parent}`).offset();
		    	if (!dragEvt) dragEvt = {"x": offset.left + 20,"y": offset.top + 10};
				let modx = parseInt(Math.max(0, dragEvt.x - offset.left));
				modinfo.left = parseInt(Math.min(modx, 375 - modinfo.width));
				modinfo.top = parseInt(Math.max(0, dragEvt.y - offset.top))
			}

		    let modid = modinfo.id, modtype = modinfo.type,
		    modfields = Mods.get_plugin_param(modtype);
		    if (modfields && modfields._one_per_page) {
		    	let sametypemod = this.modules.find(v => v.type == modtype);
				if (sametypemod) {
					let modshowname = modfields['_module_name'];
		        	this.$Notice.warning({
						title: '无法添加插件',
						desc: `一个页面只能有一个${modshowname}插件`
					});
		        	$target.remove();
		        	return false
				}
		    }

		    if (modtype == 'webpage' && this.modules.length > 0) {
				let modshowname = modfields['_module_name'];
				this.$Notice.warning({
					title: '无法添加插件',
					desc: `「Web页面」插件只能放置在一个空白页面`
				});
				$target.remove();
				return false
			}

			let childzIndex = this.childzIndex;
			this.modules.push(modinfo);
			this.modules.forEach(element => {
				if (modinfo.id != element.id && modinfo.zindex <= element.zindex
					&& modinfo.parent == element.parent) element.zindex += 1;

				let parentid = element.parent || '';
				if (modinfo.id == element.id && $.trim(parentid).length > 0
					&& !modinfo.type.startsWith('form_')) {
					let maxindex = Math.max.apply(null,
					  (childzIndex[parentid] || '0').replace(/,$/, '').split(","));
					element.zindex = maxindex + 1;
					if (element.type == 'mtitle') element.height = 50;
					if (element.type == 'navigation') element.height = 40
				}
			});

			$target.remove();EventBus.$emit("end_add_module", e);
			EventBus.$emit("user_behavior", `add_${modtype}`);
			this.$nextTick(() => setTimeout(() => {
	            EventBus.$emit(`activate_mod_${modid}`)
			}, 0))
		},
		add (e, type){
			let modinfo = Mods.get_default_plugin(type || e.target.getAttribute("data-role"));
			this.modules.push(modinfo);
			EventBus.$emit("user_behavior", `load_${type}`)
	    },
	    propShow (data){
			if ('Activated' == data.status) this.propInfo = data.target || {}
			else this.propInfo = propInfo
		},
		globalMouseDown (e){
			if (/firefox/i.test(navigator.userAgent)) window.event = e;
			let target = e.target || e.srcElement,
			filters = ['.cstlayer', '.propanel', '.page-linker',
				'.ivu-select-dropdown', '.file-manager','.sp-container'];
			if (! $(target).closest(filters).length) EventBus.$emit("mod_deactivate");
			EventBus.$emit("document_mousedown", e)
		},
	},
	props: ['id', 'height', 'ispreview'],
	components: {draggable, WpModule, Property, Setting},
}

document.oncontextmenu = () => {return false};
</script>

<style type="text/css">
body {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}
#canvas .plugin-li {height: 22px;position: relative;}
#canvas .plugin-li .drophint {background-color: #efbf1f;font-size: 12px;line-height: 22px;color: #fff;position: absolute;width: 100%;height: 22px;z-index: 200;left: 0;top: 0;text-align: center;}
#canvas .plugin-li p, #canvas .plugin-li i {display: none;visibility: hidden;}
.myhandler, .removit {color:#2d8cf0;display:none;border:1px solid #2d8cf0;background-color:#fff;border-bottom-left-radius:3px;border-bottom-right-radius:3px;position:absolute;top:1px;text-align:center;border-top:none;font-family:arial;font-weight:bold;height:20px;line-height:20px;z-index:101;}
.removit {cursor:pointer;font-size:18px;right:3px;width:24px;}
#layertip {position: absolute;display: inline-block;left: 1px;top: 0;background-color: #2d8cf0;color: #fff;font-size: 12px;line-height: 20px;padding: 1px 5px;z-index: 1002;border-radius: 2px;}
.handler-top > #layertip {top: -22px;}
</style>
<style scoped>
.editor {position: relative;min-height: 400px;width: 379px;margin: 0 calc(50% - 365px);}
.phonebottom, .phonetop {width: 379px;height: 30px;position: absolute;top: 0;left: 0;overflow: hidden;z-index: 9999;}
.phonetop {border-bottom: 1px solid #ededed;}
.phonebottom {border-top: 1px solid #ededed;}
.phonetop img, .phonebottom img {width: 379px;height: 30px;}
.phonebottom, .phonebottom img {height: 60px;}
.propanel {width: 320px;height: 100%;border-left: 1px solid #dddee1;/*box-shadow: -1px 0 6px rgba(0,0,0,.2);*/padding: 10px 0 10px 10px;}
#scroll_container {margin-top: 30px;background-color: #fff;border-left: 1px solid #ededed;border-right: 1px solid #ededed;width: 379px;}
#canvas {position: relative;padding: 0!important;width: 375px;min-height: 100%;}
#canvas > .place-holder {clear: both;overflow: hidden;width: 100%;height: 0;}
</style>


// WEBPACK FOOTER //
// editor.vue?4c52f5cf